import React, { useCallback, useEffect, useLayoutEffect, useState } from "react";
import { useDispatch, shallowEqual } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { useNoticeListQuery, useNoticePinListQuery } from "src/api/noticeAPI";
import { deleteTypeSearch, setListData, setListDataInit } from "src/store/reducers/noticeListReduce";
import { useAppSelector } from "src/store/actions/action";
import reuseQueryString from "src/utils/reuseQueryString";
import Body from "src/components/common/Body";
import Button from "src/components/common/Button";
import AlarmButton from "src/components/common/AlarmButton";
import IconButton from "src/components/common/IconButton";
import SVG from "src/utils/SVG";
import Box from "src/components/common/Box";
import SearchInput from "src/components/common/SearchInput";
import RecentKeyword from "src/components/notice/RecentKeyword";
import List from "src/components/common/List";
import SearchSortItem from "src/components/filter/SearchSortItem";
import NoticeListPinItem from "src/components/notice/NoticeListPinItem";
import NoticeListItem from "src/components/notice/NoticeListItem";
import PaginationCommon from "src/components/common/PaginationCommon";
import Chip from "src/components/common/Chip";
import NoticeFilterItem from "src/components/filter/NoticeFilterItem";
import BottomFixed from "src/components/common/BottomFixed";
import BottomModal, { RefProps } from "src/components/common/BottomModal";
import cn from "classnames";
import styled from "styled-components";
import { cloneDeep, isEmpty } from "lodash";
import { setModifyDataInit } from "../../store/reducers/modifyReduce";
import { setNoticeDataInit } from "../../store/reducers/noticeReduce";
import { checkBrandCode } from "src/utils/checkBrandCode";
import { BLOCKED_USER, SOS_NOTICE_LIST } from "../../utils/sosFunc";

const initFilterData: any = {
  typeFilter: {
    title: "공지 유형",
    data: [
      { type: "일반공지", checked: false },
      { type: "마네킨 착장", checked: false },
      { type: "매장연출", checked: false },
      { type: "영상 ", checked: false },
      { type: "비주얼", checked: false },
      { type: "기타 ", checked: false },
    ],
  },
  dateFilter: {
    title: "기간",
    data: [
      { type: "1개월", checked: false },
      { type: "3개월", checked: false },
      { type: "6개월", checked: false },
      { type: "12개월", checked: false },
      { type: "기간선택", checked: false },
    ],
  },
};

function noticeList() {
  // 글로벌
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userInfo = useAppSelector((state) => state.userReduce.userInfo, shallowEqual);
  const noticeListReduce = useAppSelector((state) => state.noticeListReduce);
  const storeCurrentPage = useAppSelector((state) => state.noticeListReduce.currentPageNumber);

  const [hasAlarm, setHasAlarm] = useState(false);

  const [api, setApi] = useState({
    apiSkip: true,
    filteredData: "",
  });
  const { apiSkip, filteredData } = api;

  const [queryString, setQueryString] = useState<any>({
    typeSearchArray: noticeListReduce.typeSearchArray, // 공지유형
    contentsSearchString: noticeListReduce.keywordSearchData, // 검색어
    asSortSearchString: noticeListReduce.sortSearchData, // sort
    myExecuteSearchString: noticeListReduce.myExecuteString, // 내이행공지
    pageSearchNumber: 0, // page
  });

  // ================================================================================================
  // API 영역
  // ================================================================================================
  const noticeList = useNoticeListQuery(filteredData, { skip: apiSkip });
  const noticePinList = useNoticePinListQuery("", { skip: apiSkip });
  const [apiCall, setApiCall] = useState(false);

  //////////SOS
  const [ugcList, setUgcList] = useState<any>({ data: { data: { data: [] } } });
  useEffect(() => {
    if (userInfo.user_id == "m1" && noticeList?.data?.data) {
      if (window.localStorage.getItem(SOS_NOTICE_LIST) || window.localStorage.getItem(BLOCKED_USER)) {
        const banNoticeList: { list: string[] | undefined } | undefined = JSON.parse(window.localStorage.getItem(SOS_NOTICE_LIST) || "{}");
        const banUserList: { list: string[] | undefined } | undefined = JSON.parse(window.localStorage.getItem(BLOCKED_USER) || "{}");
        const tempData = noticeList.data.data.data;
        const result = tempData
          .filter((res: any) => {
            if (!banNoticeList?.list?.includes(res.notice_idx)) return res;
          })
          .filter((res: any) => {
            if (!banUserList?.list?.includes(res.vmd_id)) return res;
          });
        const cloneData = cloneDeep(noticeList);
        cloneData.data.data.data = result;
        setUgcList(cloneData);
      } else {
        setUgcList(noticeList);
      }
    }
  }, [noticeList]);

  // 쿼리스트링 변경에 따른 api 호출
  useLayoutEffect(() => {
    if (queryString) {
      if (apiCall) {
        const searchFilter = reuseQueryString(queryString, searchStartDate, searchEndDate);
        setApi({
          ...api,
          filteredData: searchFilter,
          apiSkip: false,
        });
      }
    }
  }, [queryString, apiCall]);

  // ================================================================================================
  // 기능별 개발 영역
  // ================================================================================================
  // 페이지네이션
  const [currentPage, setCurrentPage] = useState<number>();
  const [totalPages, setTotalPages] = useState();

  useEffect(() => {
    setApiCall(true);
  }, []);

  useEffect(() => {
    setCurrentPage(storeCurrentPage);
    setQueryString({
      ...queryString,
      pageSearchNumber: storeCurrentPage,
    });
  }, [currentPage]);

  useEffect(() => {
    if (noticeList.isSuccess) {
      setTotalPages(noticeList.data.data.meta.totalPages);
    }
  }, [noticeList]);

  const objectChange = (currentPage: number) => {
    dispatch(
      setListData({
        currentPageNumber: currentPage,
      }),
    );
    setQueryString({
      ...queryString,
      pageSearchNumber: currentPage,
    });
    setCurrentPage(currentPage);
  };

  // 필터 기간 검색을 위한 리듀서
  const [searchStartDate, setSearchStartDate] = useState<string>("");
  const [searchEndDate, setSearchEndDate] = useState<string>("");

  // 제목 키워드 검색
  const [searchKeyword, setSearchKeyword] = useState(noticeListReduce.keywordSearchData ? noticeListReduce.keywordSearchData : "");

  const onSearchKeywords = (e: any) => {
    const contents = e.currentTarget.parentElement?.childNodes[0].value;
    setSearchKeyword(contents);
    dispatch(
      setListData({
        keywordSearchData: contents,
        currentPageNumber: 1,
      }),
    );
    setCurrentPage(1);
    setQueryString({
      ...queryString,
      pageSearchNumber: 1,
      contentsSearchString: contents,
    });

    // 기존 최근검색어 로컬스토리지 저장
    const fulfillCurrentSearch: any = window.localStorage.getItem("fulfillCurrentSearch");
    let JsonData: Array<string> = [];
    if (fulfillCurrentSearch) {
      JsonData = JSON.parse(fulfillCurrentSearch);
    }
    for (let i = 0; i < JsonData.length; i++) {
      if (JsonData[i] === contents) {
        return;
      }
    }
    if (contents) {
      if (JsonData.length < 4) {
        JsonData.push(contents);
        window.localStorage.setItem("fulfillCurrentSearch", JSON.stringify(JsonData));
      } else {
        JsonData.splice(0, 1);
        JsonData.push(contents);
        window.localStorage.setItem("fulfillCurrentSearch", JSON.stringify(JsonData));
      }
    }
  };

  // 키워드 엔터로 검색
  const onKeyPress = (e: any) => {
    if (e.key === "Enter") {
      onSearchKeywords(e);
    }
  };

  // 검색어 삭제
  const deleteSearchContents = () => {
    if (searchKeyword) {
      setSearchKeyword("");
      dispatch(
        setListData({
          keywordSearchData: "",
          currentPageNumber: 1,
        }),
      );
      setCurrentPage(1);
      setQueryString({
        ...queryString,
        pageSearchNumber: 1,
        contentsSearchString: "",
      });
    }
  };

  // 내이행포함 공지 필터
  const [MyFulfillToggle, setMyFulfillToggle] = useState(noticeListReduce.myExecuteString === "Y" ? true : false);

  const MyFulfillBtn = () => {
    if (MyFulfillToggle) {
      setQueryString({ ...queryString, myExecuteSearchString: "", pageSearchNumber: 1 });
      dispatch(
        setListData({
          myExecuteString: "",
        }),
      );
    } else {
      setQueryString({ ...queryString, myExecuteSearchString: "Y", pageSearchNumber: 1 });
      dispatch(
        setListData({
          myExecuteString: "Y",
        }),
      );
    }
    setCurrentPage(1);
    setMyFulfillToggle(!MyFulfillToggle);
  };

  // 필터모달 관련
  const [filterData, setFilterData] = useState<any>(initFilterData);
  const [applyFilterData, setApplyFilterData] = useState<any>(initFilterData);
  const [applyFilterItem, setApplyFilterItem] = useState(noticeListReduce.typeSearchArray);
  const filterModalRef = React.useRef<RefProps>(null);
  const [initVisible, setInitVisible] = useState<boolean>(false);

  useEffect(() => {
    setFilterData(noticeListReduce.filterList);
    setApplyFilterData(noticeListReduce.applyFilterList);
    setApplyFilterItem(noticeListReduce.typeSearchArray);
    setSearchKeyword(noticeListReduce.keywordSearchData!);
    // 달력선택용
    setSearchStartDate(noticeListReduce.searchStartDate!);
    setSearchEndDate(noticeListReduce.searchEndDate!);
    // console.log("noticeListReduce", noticeListReduce);
  }, [noticeListReduce]);

  useEffect(() => {
    setQueryString({
      ...queryString,
      contentsSearchString: searchKeyword,
      pageSearchNumber: 1,
    });
  }, [searchKeyword]);

  useEffect(() => {
    dispatch(
      setListData({
        applyFilterList: noticeListReduce.filterList,
      }),
    );
  }, []);

  const openFilterModal = useCallback(() => {
    if (filterModalRef.current) filterModalRef.current.modalOpen();
  }, []);

  const initBtn = () => {
    // noticeListReduce.filterList만 initState로 초기화
    dispatch(setListDataInit());
  };

  const setInitFunc = (propsSelectedFliterCheck: boolean) => {
    setInitVisible(propsSelectedFliterCheck);
  };

  const confirmBtn = () => {
    setApplyFilterItem(noticeListReduce.typeSearchArray);
    dispatch(
      setListData({
        applyFilterList: noticeListReduce.filterList,
        typeSearchArray: noticeListReduce.typeSearchArray,
        currentPageNumber: 1,
      }),
    );
    setCurrentPage(1);
    setQueryString({
      ...queryString,
      pageSearchNumber: 1,
      typeSearchArray: noticeListReduce.typeSearchArray,
    });
    if (filterModalRef.current) filterModalRef.current.modalClose();
  };

  const closeBtn = () => {
    dispatch(
      setListData({
        filterList: noticeListReduce.applyFilterList,
        typeSearchArray: noticeListReduce.typeSearchArray,
      }),
    );
    if (filterModalRef.current) filterModalRef.current.modalClose();
  };

  // 필터 선택시 박스 스크롤 끝으로 이동
  const filterBoxRef = React.useRef<HTMLDivElement>(null);
  const [filterSelected, setFilterSelected] = useState(false);
  useEffect(() => {
    if (filterBoxRef.current && filterSelected) {
      const scrollX = filterBoxRef.current.scrollLeft;
      const scrollXWidth = filterBoxRef.current.scrollWidth;
      filterBoxRef.current.scrollTo({ top: 0, left: scrollX + scrollXWidth, behavior: "smooth" });
      setFilterSelected(false);
    }
    setFilterSelected(true);
  }, [applyFilterItem]);

  // 필터 칩 삭제
  const deleteSelected = (v: any, i: number) => {
    // store에 typeSearchArray(선택된요소) 지워주기 : 필터 옆 chip 제거
    dispatch(deleteTypeSearch(v));
    const remainChips = noticeListReduce.typeSearchArray?.filter((type) => type !== v);
    const deletedChips = noticeListReduce.typeSearchArray?.filter((type) => type === v).toString();

    setApplyFilterItem(remainChips);

    const getSelectedType = applyFilterData.typeFilter.data.map((value: any) => (value.type === deletedChips ? { ...value, checked: false } : { ...value }));
    const getSelectedDate = applyFilterData.dateFilter.data.map((value: any) => (value.type === deletedChips ? { ...value, checked: false } : { ...value }));

    dispatch(
      setListData({
        filterList: {
          typeFilter: {
            title: "공지 유형",
            data: getSelectedType,
          },
          dateFilter: {
            title: "기간",
            data: getSelectedDate,
          },
        },
        applyFilterList: {
          typeFilter: {
            title: "공지 유형",
            data: getSelectedType,
          },
          dateFilter: {
            title: "기간",
            data: getSelectedDate,
          },
        },
      }),
    );

    setQueryString({
      ...queryString,
      pageSearchNumber: 1,
      typeSearchArray: remainChips,
    });
  };

  // 정렬모달 관련
  const [sortIdx, setSortIdx] = useState<number>(noticeListReduce.sortSearchIdx ? noticeListReduce.sortSearchIdx : 0);
  const [sortName, setSortName] = useState<string>(noticeListReduce.sortSearchData ? noticeListReduce.sortSearchData : "최신순");
  const sortModalRef = React.useRef<RefProps>(null);

  const openSortModal = useCallback(() => {
    if (sortModalRef.current) sortModalRef.current.modalOpen();
  }, []);

  const sortBtn = (e: any) => {
    const sortName = e.target.textContent;
    setSortName(sortName);
    dispatch(
      setListData({
        sortSearchData: sortName,
      }),
    );
    setQueryString({
      ...queryString,
      // pageSearchNumber: 1,
      asSortSearchString: sortName,
    });
    if (sortModalRef.current) sortModalRef.current.modalClose();
  };

  const childrenSortIdxFunc = (idx: number) => {
    setSortIdx(idx);
    dispatch(
      setListData({
        sortSearchIdx: idx,
      }),
    );
  };

  function registerPage() {
    dispatch(setModifyDataInit());
    dispatch(setNoticeDataInit());
    navigate("/notice-register");
  }
  return (
    <>
      <header className={cn({ hasAlarm: hasAlarm })}>
        <div>
          <Button variant="text" className="btn-back no-ico">
            공지
          </Button>
        </div>
        <div className="btn-box">
          <AlarmButton />
          <IconButton btnName="마이페이지" className="user" onClick={() => navigate("/profile/" + userInfo.user_id)}>
            <SVG name="userBlack" />
          </IconButton>
        </div>
      </header>

      <Body isTabbar={true}>
        <Box pd="20px 15px">
          <SearchInput
            type="text"
            id="search-input"
            placeholder="검색어를 입력해주세요."
            defaultValue={searchKeyword}
            onClick={(e) => onSearchKeywords(e)}
            onKeyPress={(e) => onKeyPress(e)}
            deleteSearchContentFunc={deleteSearchContents}
          />
        </Box>

        <RecentKeyword />

        <FilterBtnSet ref={filterBoxRef}>
          <Button variant="contained" br="round" color="secondary" size="medium" onClick={openFilterModal}>
            <SVG name="filter" width={16} height={16} viewBox="0 0 16 16" />
            필터
          </Button>
          <Button variant="contained" br="round" color="secondary" size="medium" onClick={openSortModal}>
            <SVG name="sort" width={14.637} height={16.348} viewBox="0 0 14.637 16.348" />
            {sortName}
          </Button>
          {userInfo.user_type === "S" && (
            <Button className="only-new" variant="contained" br="round" color={MyFulfillToggle ? "active" : "secondary"} size="medium" onClick={MyFulfillBtn}>
              {MyFulfillToggle ? (
                <SVG name="toggleActive" width={16} height={16} viewBox="0 0 16 16" />
              ) : (
                <SVG name="toggle" width={16} height={16} viewBox="0 0 16 16" />
              )}
              내 이행 공지
            </Button>
          )}
          {applyFilterItem &&
            applyFilterItem.map((v: any, i: number) => {
              return (
                <Chip variant="contained" deleted={true} key={i} onDelete={() => deleteSelected(v, i)}>
                  {v}
                </Chip>
              );
            })}
        </FilterBtnSet>

        {/* 고정 공지건 최대 5개 노출 : 1페이지, 필터 또는 키워드 검색이 아닌 경우에만 노출 */}
        {noticePinList.isSuccess && currentPage == 1 && isEmpty(applyFilterItem) && isEmpty(searchKeyword) && (
          <ul>
            <NoticeListPinItem data={noticePinList.data} />
          </ul>
        )}

        {/* 공지건 한페이지당 20개 노출 */}
        <BottomPadding className={cn({ withFixedBtn: userInfo.user_type === "E" })}>
          {noticeList.isSuccess && (
            <List pd="0 15px" itemPd="16px 0">
              {/*<NoticeListItem data={noticeList.data} />*/}
              <NoticeListItem data={userInfo.user_id == "m1" && ugcList ? ugcList.data : noticeList.data} />
            </List>
          )}

          {totalPages !== undefined && totalPages > 1 && (
            <PaginationCommon item_count={20} current_page={currentPage} total_page={totalPages} objectChange={objectChange} viewName="noticeList" />
          )}
        </BottomPadding>

        {/* 본사 공지 등록 버튼 노출 */}
        {userInfo.user_type === "E" && checkBrandCode(userInfo.brand) && (
          <BottomFixed>
            {/*<Link to={"/notice-register"}>*/}
            <IconButton btnName="글등록하기" onClick={() => registerPage()}>
              <SVG name="write" width={53} height={53} viewBox="0 0 53 53" />
            </IconButton>
            {/*</Link>*/}
          </BottomFixed>
        )}
      </Body>

      <BottomModal
        ref={filterModalRef}
        onClick={() => initBtn()}
        onClick2={() => confirmBtn()}
        onClick3={() => closeBtn()}
        modalTitle="검색 필터"
        headerBtn="초기화"
        footerBtn="적용"
        dimClickFun={closeBtn}
        initVisible={initVisible}
      >
        <List pd="0 15px" itemPd="20px 0">
          <NoticeFilterItem
            filterList={filterData}
            stateStartDate={searchStartDate}
            stateEndDate={new Date(searchEndDate).setDate(new Date(searchEndDate).getDate() - 1)}
            setInitFunc={(filter: any) => setInitFunc(filter)}
          />
        </List>
      </BottomModal>

      <BottomModal modalTitle="정렬" ref={sortModalRef}>
        <List pd="0 15px">
          <SearchSortItem sortData={["최신순", "오래된순", "제목순"]} onClick={(e) => sortBtn(e)} initIdx={sortIdx} parentSortIdxFunc={childrenSortIdxFunc} />
        </List>
      </BottomModal>
    </>
  );
}

const FilterBtnSet = styled.div`
  overflow: hidden;
  overflow-x: scroll;
  width: 100%;
  padding: 15px;
  border-top: 1px solid ${({ theme }) => theme.color.linePrimary};
  border-bottom: 1px solid ${({ theme }) => theme.color.linePrimary};
  ${({ theme }) => theme.flexBox.flexMixin("row", "flex-start")}
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera*/
  }
  > * {
    flex: 0 0 auto;
    margin-right: 10px;
    &:last-child {
      margin-right: 0;
    }
  }
  > button {
    > svg {
      position: relative;
      top: -1px;
    }
  }
  .only-new {
    > svg {
      top: 2px;
      left: 2px;
    }
  }
`;

const BottomPadding = styled.div`
  &.withFixedBtn {
    padding-bottom: 60px;
  }
`;

export default noticeList;
